module.exports = __webpack_public_path__ + "static/media/ensembleprix.fb2ec267.JPG";